var lib_core = require("lib-core");

var EcadioModelSelectorTrayStateMachine = function (root, model, editor3dModel, modelUploadSM, loadingModel, parentName) {
    var self = this;

    this.root = root;
    this.model = model;
    this.editor3dModel = editor3dModel; 
    this.modelUploadSM = modelUploadSM; 
    this.loadingModel = loadingModel;
    this.parentName = parentName;

    lib_core.StateMachine.call(self);

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.ECADIO_RESULT_SELECTED;
        },
        function(cEvent){
            self.loadingModel.addLoad("Importing", "Importing Data.");

            self.fetchAndUpload3dModelToCS(cEvent.data('url'));
        }
    );

    this.searchTransition = self.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.UI_TRAY_TAB_SEARCH &&
                cEvent.data('parentName') == self.parentName &&
                cEvent.data('tabName') == self.model.name() );
        },
        function(cEvent){
            self.model.query(cEvent.data('val'));
        }
    );
};

lib_core.inherit(EcadioModelSelectorTrayStateMachine, lib_core.StateMachine);
module.exports = EcadioModelSelectorTrayStateMachine;

EcadioModelSelectorTrayStateMachine.prototype.fetchAndUpload3dModelToCS = function(modelUrl) {
    var self = this;

    // get the file from remote and upload it to CS
    $.ajax({
        url: modelUrl,
        type: 'GET',
        dataType: 'text',
    })
    .done(function(data){
        var blob = new Blob([data], {type : 'text/plain'});

        //upload to cs
        self.loadingModel.removeLoad("Importing");
        self.modelUploadSM.consumeFile(blob, modelUrl.slice(modelUrl.lastIndexOf('/') + 1), true);
    })
    .fail(function(jqxhr, settings, exception) {
        self.loadingModel.removeLoad("Importing");
        self.modelUploadSM.translationError(exception);
    });
};
